import React, { useState, useEffect } from 'react';
import { Table, TableBody,Button, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import isGHMC from '../../../Common/helper/helpar';
import { useLocation, useNavigate } from 'react-router-dom';
import ExcelJS from "exceljs";
import { API_BASE_URL1 } from '../../../Services/baseApiUrl';
import { AllInnerReportOfTotalDeployment } from '../../../Apis/userCreationApi';
import Loader from '../../../Common/Loader/loader';

const InnerReportOfTotalDeployment = () => {
    const navigate = useNavigate()
  const location = useLocation();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const isProd = isGHMC();
  const data1 = location.state;
  const ownerTypeId = localStorage.getItem("selectedOwnerType")
  const vehicleTypeId = localStorage.getItem("selectedVehicleType")
  // Fetch data from the API
  const fetchInnerReportData = async () => {
    setIsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";
      const fromDate = data1.fromDate; // Current date start time
      const toDate = data1.toDate;     // Current date end time
      const data = await AllInnerReportOfTotalDeployment(
        data1.transferStationId,
        fromDate,
        toDate,
        data1.shiftId,
        ownerTypeId,
        vehicleTypeId
      );
      setRows(data);
      setFilteredRows(data);
    } catch (error) {
      console.error('Error fetching inner report data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Call fetchInnerReportData when the component mounts
  useEffect(() => {
    if (data1) {
      fetchInnerReportData(data1);
    }
  }, [data1]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 100));
    setPage(0); // Reset to first page when rows per page changes
  };

  const shiftMapping = {
    '1': 'Morning',
    '2': 'Afternoon',
    '3': 'Evening',
  };

  // Calculate the index range for the current page
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = filteredRows.slice(startIndex, endIndex);


  const downloadAsExcel = async () => {
    // Determine if the data is sorted or not
    
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Teritary Total Deployment Report");

    // Define styles
    const boldFont = { bold: true };

    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Teritary Total Deployment Report Generated on: ${formattedDate}, ${formattedTime}`;

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add "Zone Details" header
    worksheet.addRow(["", "", "Teritary Total Deployment Report", ""]);
    worksheet.mergeCells(2, 2, 2, 6);
    worksheet.getCell(2, 2).value = "Teritary Total Deployment Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Define table headers
    const tableHeaderRow = worksheet.addRow([
      "S.No",
     "Vehicle Number",
     "Driver Name",
      "Source Location",
      "Destination Location",
      "Vehicle Type",
      "Vehicle Capacity",
      "Owner Type",
     " Operation Type",
     " Shift",
      "Deployment Time"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 14) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Background color
          bgColor: { argb: "FFFFFFFF" } // Text color
        };
      }
    });

    // Add data rows
    rows.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.vehicleNumber?? "N/A",
        item.driverName?? "N/A",
        item.deploymentLocation?? "N/A",
        item.destinationLocation?? "N/A",
        item.vehicleTypeName?? "N/A",
        item.vehicleCapacity?? "N/A",
        item.ownerTypeName?? "N/A",
        item.operationType?? "N/A",
        item.shiftId?? "N/A",
        item.deploymentDateTime,
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.alignment = { horizontal: "left" };
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
      
    ];

    // Save the workbook to a file
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "TeritaryTotalReport.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  return (
    <div>
      {isLoading && <Loader/> }
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
          <div className="page-header"></div>
            <div class="row" style={{ textAlign: "justify" }}>
            </div>
          <div className="card">
          <div className="card-body p-3">
          <div className="d-flex justify-content-end mt-3 mb-3">
            {/* <h4 className="text-start mb-3">Teritary Total Deployment Report</h4> */}
            <button
              variant="contained"
              className="btn btn-secondary"
            //   color="error" // Red color
              onClick={() => navigate(-1)} // Navigate back
              // sx={{ marginBottom: '20px',marginTop:'20px',backgroundColor:'red' }} // Add some margin for spacing
            >
              Back
            </button>
            <button className="btn btn-excel" 
                    onClick={downloadAsExcel}
                  >
                     <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>
            </div>
         
            <div className="top-header">
                  <span>
                    {" "}
                    Teritary Total Deployment Report
                  </span>
                </div>
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                      <TableContainer
                        component={Paper}
                        sx={{
                          width: '95%',
                          margin: '20px',
                          maxHeight: '500px',
                          overflowY: 'auto',
                          boxShadow: '0px 3px 6px rgba(0,0,0,0.1)',
                          borderRadius: '10px',
                          border: '1px solid #ccc',
                        }}
                      >
                        <Table sx={{ minWidth: 700, borderCollapse: 'collapse' }}>
                          <TableHead
                            className={`${isProd ? 'bg-ghmc' : 'bg-swm'}`}
                            sx={{
                              position: 'sticky',
                              top: 0,
                              zIndex: 1,
                            }}
                          >
                            <TableRow sx={{ paddingTop: '20px' }}>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>S.No</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Vehicle Number</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Driver Name</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Source Location</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Destination Location</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Vehicle Type</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Vehicle Capacity</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Owner Type</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Operation Type</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Shift</TableCell>
                              <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Deployment Time</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {currentRows.length > 0 ? (
                              currentRows.map((row, index) => (
                                <TableRow
                                  key={row.sno}
                                  sx={{
                                    backgroundColor: isProd
                                      ? index % 2 === 0
                                        ? '#8fc9ff'
                                        : '#aed8ff'
                                      : index % 2 === 0
                                        ? '#F8CCCD'
                                        : '#ffeded',
                                  }}
                                >
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{startIndex + index + 1}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.vehicleNumber || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.driverName || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd',}}>{row.deploymentLocation || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.destinationLocation || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd'}}>{row.vehicleTypeName || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd'}}>{row.vehicleCapacity || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center' ,border: '1px solid #ddd'}}>{row.ownerTypeName || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.operationType || 'N/A'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{shiftMapping[row.shiftId] || 'Unknown'}</TableCell>
                                  <TableCell sx={{ textAlign: 'center',border: '1px solid #ddd', }}>{row.deploymentDateTime || 'N/A'}</TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={8} sx={{ textAlign: 'center' }}>No data available</TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        component="div"
                        count={filteredRows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
  );
};

export default InnerReportOfTotalDeployment;
